function PriorityBadgeController () {
  var ctrl = this

  ctrl.mLabelColors = {
    URGENT: 'red',
    HIGH: 'orange',
    MEDIUM: 'yellow',
    LOW: 'green'
  }
}

export { PriorityBadgeController }
